export function XCircleIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M7.00033 12.8332C10.222 12.8332 12.8337 10.2216 12.8337 6.9999C12.8337 3.77824 10.222 1.16656 7.00033 1.16656C3.77866 1.16656 1.16699 3.77824 1.16699 6.9999C1.16699 10.2216 3.77866 12.8332 7.00033 12.8332Z" fill="#101828" />
      <path d="M8.75 5.25L5.25 8.75M5.25 5.25L8.75 8.75" stroke="white" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

XCircleIcon.displayName = 'XCircleIcon';
